export const HOME = "/";
export const SIGN_UP = "/signup";
export const SIGN_IN = "/signin";
export const PASSWORD_FORGET = "/pw-forget";
export const SIGN_OUT = "/signout";
export const GAME = "/game";
export const PHOTOS = "/photos";
export const ACCOUNT = "/account";
